module.exports = __webpack_public_path__ + "img/fr.6d7b4af7.svg";